import { useQuery } from 'react-query';
import { getEmployeeNotes } from 'RestAPIs/employees/notes';

const useGetEmployeeNotes = (employeeId: number) => {
  const { data, isFetching, isError, refetch } = useQuery(
    ['employeeNotes', 'list', employeeId],
    async () => {
      const { data } = await getEmployeeNotes(employeeId);
      return data;
    }
  );
  return { data, isFetching, isError, refetch };
};

export default useGetEmployeeNotes;
